import React from "react";
import '../styles/Overview.css';

const Overview = () => {
    return (
        <section className="overview-section">
            <div className="overview-content">
                <div className="text-content">
                    <h1 className="starter-text">Menez votre projet avec passion</h1>
                    <h2 className="added-text">Chaque étape en avant est une étape vers le succès</h2>
                </div>
                
            
            </div>
        </section>
    );
};

export default Overview;
